import { ContextPack } from "@/api/studio/contexts/types/context.type";
import { Point } from "@/api/studio/data/types/point.type";
import { Button } from "@/components/ui/button";
import { useSegment } from "@/hooks/use-segment";

/* Prop Types */
interface AddContextDropzoneProps {
  contextPack: ContextPack;
  isUpdateContextPackPending: boolean;
  setPoints: (points: Point[]) => void;
  assetIndex: number;
}

/*
 * AddContextDropzone component
 */
export const AddContextDropzone = ({ contextPack, isUpdateContextPackPending, setPoints, assetIndex }: AddContextDropzoneProps) => {
  /* Hooks */
  const { segmentTrackEvent } = useSegment();

  /* Handlers */
  const handleAddDropzone = async () => {
    if (!contextPack) return;

    const assetWidth = contextPack.contexts[assetIndex].width;
    const assetHeight = contextPack.contexts[assetIndex].height;

    // calculate the size of the dropzone, minimum size is 100px
    const rectSize = Math.max(100, Math.floor(assetWidth / 10));

    // place a dropzone in the center of the image - we want the dropzone to be a square
    // and the size to be 10% of the image size
    const points = [
      { x: Math.floor(assetWidth / 2 - rectSize), y: Math.floor(assetHeight / 2 - rectSize) },
      { x: Math.floor(assetWidth / 2 + rectSize), y: Math.floor(assetHeight / 2) },
      { x: Math.floor(assetWidth / 2 + rectSize), y: Math.floor(assetHeight / 2 + rectSize) },
      { x: Math.floor(assetWidth / 2), y: Math.floor(assetHeight / 2 + rectSize) },
    ];

    // save the dropzone against the context with a default background color
    setPoints(points);

    // Segment tracking
    segmentTrackEvent("Context Dropzone Added", {
      contextPackId: contextPack.id,
      contextPackName: contextPack.name,
      useCaseId: contextPack.useCase.id,
      useCaseName: contextPack.useCase.name,
      contextCount: contextPack.contextCount,
    });
  };

  /* Render */
  return (
    <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-base-100 rounded-2xl p-6 z-30 w-[337px]">
      <video src="/videos/context-dropzone-animation.webm" className="w-auto pb-2" autoPlay muted loop />
      <div className="flex justify-between items-center pt-3">
        <p>Add dropzone</p>
        <Button variant="primary" onClick={handleAddDropzone} disabled={isUpdateContextPackPending}>
          Add
        </Button>
      </div>
    </div>
  );
};
